<template>
    <div>

        <!-- <pre>{{getConfiguracion}}</pre> -->
        <v-stepper
        v-model="getConfiguracion.wizard_step"
        :vertical="false"
        :alt-labels="false"
        >
            <template>
                <v-row>

                    <!-- <v-col cols="auto">


                        <template v-for="n in steps">
                            <v-stepper-step
                            :key="`${n}-step`"
                            :complete="e1 > n"
                            :step="n"
                            :editable="true"
                            class="py-0"
                            >
                                kinverly navas hyhy {{ n }}
                            </v-stepper-step>
                        </template>
                        <v-col class="vl"></v-col>
                    </v-col>


                    <v-col>

                        <v-stepper-items>
                            <v-stepper-content
                            v-for="n in steps"
                            :key="`${n}-content`"
                            :step="n"
                            >
                                <v-card
                                class="mb-12"
                                color="grey lighten-1"
                                height="200px"
                                >

                                </v-card>

                                <v-btn
                                color="primary"
                                @click="nextStep(n)"
                                >
                                    Continue
                                </v-btn>

                                <v-btn text>Cancel</v-btn>
                            </v-stepper-content>
                        </v-stepper-items>

                    </v-col> -->


                    <!-- columna wizard -->
                    <v-col cols="auto">


                        <template>
                            <v-stepper-step
                            :key="`1-step`"
                            :complete="getConfiguracion.wizard_step > 1"
                            :step="1"
                            :editable="true"
                            class="py-0"
                            >
                                Información de la evaluación
                            </v-stepper-step>
                        </template>
                        <v-col class="vl"></v-col>


                        <template>
                            <v-stepper-step
                            :key="`2-step`"
                            :complete="getConfiguracion.wizard_step > 2"
                            :step="2"
                            :editable="true"
                            class="py-0"
                            >
                                Seleccionar Indicadores
                            </v-stepper-step>
                        </template>
                        <v-col class="vl"></v-col>



                        <template>
                            <v-stepper-step
                            :key="`3-step`"
                            :complete="getConfiguracion.wizard_step > 3"
                            :step="3"
                            :editable="true"
                            class="py-0"
                            >
                                Agregar preguntas
                            </v-stepper-step>
                        </template>
                        <v-col class="vl"></v-col>



                        <template>
                            <v-stepper-step
                            :key="`4-step`"
                            :complete="getConfiguracion.wizard_step > 4"
                            :step="4"
                            :editable="true"
                            class="py-0"
                            >
                                Asociar Indicadores
                            </v-stepper-step>
                        </template>
                        <v-col class="vl"></v-col>



                        <template>
                            <v-stepper-step
                            :key="`5-step`"
                            :complete="getConfiguracion.wizard_step > 5"
                            :step="5"
                            :editable="true"
                            class="py-0"
                            >
                                Programar Evaluación
                            </v-stepper-step>
                        </template>



                    </v-col>



                    <!-- columna contenido -->
                    <v-col>

                        <v-stepper-items>
                            <v-stepper-content
                            :key="`1-content`"
                            :step="1"
                            >




                                <WizardCabeceraEval></WizardCabeceraEval>



                               <!--  <v-btn
                                color="primary"
                                @click="nextStep(1)"
                                >
                                    Continue
                                </v-btn>

                                <v-btn text>Cancel</v-btn> -->
                            </v-stepper-content>


                            <v-stepper-content
                            :key="`2-content`"
                            :step="2"
                            >

                                    <WizardSeleccionIndicadoresEval></WizardSeleccionIndicadoresEval>




                            </v-stepper-content>



                            <v-stepper-content
                            :key="`3-content`"
                            :step="3"
                            >
                                <v-card
                                class="mb-12"
                                color="grey lighten-1"
                                height="200px"
                                >
                                    <WizardPreguntasEval></WizardPreguntasEval>

                                </v-card>

                                <v-btn
                                color="primary"
                                @click="nextStep(3)"
                                >
                                    Continue
                                </v-btn>

                                <v-btn text>Cancel</v-btn>
                            </v-stepper-content>





                            <v-stepper-content
                            :key="`4-content`"
                            :step="4"
                            >
                                <v-card
                                class="mb-12"
                                color="grey lighten-1"
                                height="200px"
                                >
                                    <WizardAsociarIndicadoresEval></WizardAsociarIndicadoresEval>

                                </v-card>

                                <v-btn
                                color="primary"
                                @click="nextStep(4)"
                                >
                                    Continue
                                </v-btn>

                                <v-btn text>Cancel</v-btn>
                            </v-stepper-content>




                            <v-stepper-content
                            :key="`5-content`"
                            :step="5"
                            >
                                <v-card
                                class="mb-12"
                                color="grey lighten-1"
                                height="200px"
                                >
                                <WizardProgramarEval></WizardProgramarEval>

                                </v-card>

                                <v-btn
                                color="primary"
                                >
                                    Continue
                                </v-btn>

                                <v-btn text>Cancel</v-btn>
                            </v-stepper-content>




                        </v-stepper-items>

                    </v-col>
                </v-row>
            </template>
        </v-stepper>


    </div>
</template>





<script>
    // import axios from '../../../../helpers/axios'
    import { mapMutations, mapGetters } from 'vuex';
    import WizardCabeceraEval from './wizardCabeceraEval.vue'
    import WizardSeleccionIndicadoresEval from './wizardSeleccionIndicadoresEval.vue'
    import WizardPreguntasEval from './wizardPreguntasEval.vue'
    import WizardAsociarIndicadoresEval from './wizardAsociarIndicadoresEval.vue'
    import WizardProgramarEval from './wizardProgramarEval.vue'

    export default {
        components:{
            WizardCabeceraEval, WizardSeleccionIndicadoresEval,
            WizardPreguntasEval, WizardAsociarIndicadoresEval,
            WizardProgramarEval
        },



        data: () => ({

            //steps: 5,

            editable: true,

        }),


        computed: {
            ...mapGetters('gestEvaluacion', ['getConfiguracion'])

        },



        watch: {
            /* steps (val) {
                if (this.e1 > val) {
                this.e1 = val
                }
            },
            */

            vertical () {
                this.getConfiguracion.wizard_step = 2
                requestAnimationFrame(() => this.getConfiguracion.wizard_step = 1) // Workarounds
            },
        },



        methods: {
            ...mapMutations('gestEvaluacion', ['setWizard']),



            /* onInput (val) {
                this.steps = parseInt(val)
            }, */



            nextStep (n) {
                /* if (n === this.steps) {
                    this.e1 = 1
                } else {
                    this.e1 = n + 1
                } */

                this.getConfiguracion.wizard_step = n + 1
            },
        }

    }
</script>






<style scoped>





    .vl {
        border-left: 2px solid black;
        height: 50px;
        margin-left: 35px;
        /* width: 50% */
    }
</style>